export const GET_ALL_NUMERISATION_REQUEST = "GET_ALL_NUMERISATION_REQUEST";
export const GET_ALL_NUMERISATION_SUCCESS = "GET_ALL_NUMERISATION_SUCCESS";
export const GET_ALL_NUMERISATION_FAIL = "GET_ALL_NUMERISATION_FAIL";

export const ADD_NUMERISATION_REQUEST = "ADD_NUMERISATION_REQUEST";
export const ADD_NUMERISATION_SUCCESS = "ADD_NUMERISATION_SUCCESS";
export const ADD_NUMERISATION_FAIL = "ADD_NUMERISATION_FAIL";

export const UPDATE_NUMERISATION_REQUEST = "UPDATE_NUMERISATION_REQUEST";
export const UPDATE_NUMERISATION_SUCCESS = "UPDATE_NUMERISATION_SUCCESS";
export const UPDATE_NUMERISATION_FAIL = "UPDATE_NUMERISATION_FAIL";

export const DELETE_NUMERISATION_REQUEST = "DELETE_NUMERISATION_REQUEST";
export const DELETE_NUMERISATION_SUCCESS = "DELETE_NUMERISATION_SUCCESS";
export const DELETE_NUMERISATION_FAIL = "DELETE_NUMERISATION_FAIL";
